
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 276.7 276.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","fill":"currentColor","d":"M26.2 253.1c1.9 14.8 15.5 25.2 30.3 23.3h.1l196.6-26c14.8-1.9 25.2-15.5 23.3-30.3v-.1l-26-196.6C248.6 8.6 235-1.8 220.2.1h-.1l-196.6 26C8.7 28.2-1.7 41.7.2 56.5v.1l26 196.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M144.4 169.1c-10.9 1.4-18.5 11.4-17.1 22.3 1.4 10.9 11.4 18.5 22.3 17.1 10.9-1.4 18.5-11.4 17.1-22.3-1.5-10.9-11.4-18.5-22.3-17.1zM133.8 68.4c-19.3 1.8-36 13.9-43.8 31.6-1.4 2.7-.4 6 2.3 7.5l14.3 8.1c2.7 1.5 6.1.6 7.7-2 5.9-9.8 10.2-15.6 21.1-17.1 8.3-1.1 19.4 2.9 20.4 11 .8 6.1-3.8 9.9-11.4 15.6-12 5.9-19.2 18.4-18.5 31.8l.5 4.1c.4 3.1 3.3 5.3 6.4 4.9l21.4-2.8c3.1-.4 5.3-3.3 4.9-6.4l-.4-3c-1.5-11.6 32.3-16.6 28.2-48-3.1-23.6-30.1-38.3-53.1-35.3z"}})])
          )
        }
      }
    